<template>
    <ConfigProvider :locale="zhCN">
        <Head>
            <title>{{metaTitle}}</title>
            <meta name="keywords" :content="metaKeywords">
        </Head>
        <div class="box" ref="box" :class="{
            'opacity-0': !isMounted
        }">
            <div class="content-box" ref="contentBox">
                <slot></slot>
            </div>
            <BackTop :style="{
                    bottom: '80px',
                    right: '60px',
                }">
                <div class="btn-return-top">
                    <span class="pt-icons-return-top"></span>
                </div>
            </BackTop>
        </div>
        <PageModal></PageModal>

    </ConfigProvider>
</template>

<script setup lang="ts">
import {BackTop, ConfigProvider} from "ant-design-vue";
import {computed, onMounted, ref} from "vue";
import {Head, usePage} from "@inertiajs/vue3"
import zhCN from "ant-design-vue/es/locale/zh_CN";

// import {Modal as InertiaModal, useModal} from "momentum-modal"
import {Modal as InertiaModal, useModal} from "@/packages/momentum-modal"
import PageModal from "@/Components/Common/ModalType/PageModal.vue";

const box = ref()
const contentBox = ref()
const isMounted = ref(false)

const metaTitle = computed(() => {
    if (usePage().props.meta_title) {
        return usePage().props.meta_title + '-批图网'
    }
    return '批图网-免费高品质素材库-提供P图、设计模板和精美作品'
})

const metaKeywords = computed(() => {
    const de = '批图网,批图,P图,素材,图库,模板,主图精修,详情页,精品素材,精品图库,精美作品,素材库,设计图库,设计素材,摄影素材'
    if (usePage().props.meta_keywords) {
        return usePage().props.meta_keywords + `,${de}`
    }
    return de
})

onMounted(() => {
    isMounted.value = true
})

</script>

<style lang="less">
// Styles for Scroller
::-webkit-scrollbar {
    width: 14px;

    &-thumb {
        background: rgba(0, 0, 0, .3);
        -webkit-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
            background: rgba(0, 0, 0, .4);
        }
    }

    &-track {
        width: 14px;
        border-radius: 4px;
        background: #F3F5F7;
    }
}
</style>

<style scoped lang="less">
.box {
    position: relative;
    width: 100%;
    min-width: 1200px;
    box-sizing: border-box;

    .content-box {
        padding-bottom: 60px;
    }

    .btn-return-top {
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #989898;
        color: #989898;
        width: 46px;
        height: 46px;
        border-radius: 18px;
        transition: all .3s;

        &:hover {
            background: #989898;
            color: #FFFFFF;
        }

        span {
            font-size: 26px;
        }

    }

}
</style>
